export class ConditionComponentInformation {
  serialNav: number;
  code: string;
  componentCondition: {
    name: string;
    status: number;
    deviation: number;
  }[];

  static mapFromTurbines(turbines: any, turbine: number) {
    this.sortTurbines(turbines, turbine);
    return turbines.map((t: any) => {
      return new ConditionComponentInformation({
        serialNav: t.serialNav,
        code: t.code,
        componentCondition: t.componentCondition.sort((a, b) => a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)).map((signal: any) => Object.assign({
          name: signal.name,
          deviation: signal.deviation * 100,
          status: signal.status
        }))
      });
    });
  }

  static sortTurbines(turbines: [], turbine: any) {
    const sorted = turbines.sort((a: any, b: any) => a.code.localeCompare(b.code, undefined, { numeric: true, sensitivity: 'base' }));
    const index = sorted.findIndex((s: any) => s.serialNav === turbine);
    return sorted.unshift(sorted.splice(index, 1)[0]);
  }

  constructor(init: Partial<ConditionComponentInformation>) {
    Object.assign(this, init);
  }

}
